import parsePhoneNumber from 'libphonenumber-js';

/**
 * Get country code from phone number
 * @param {string} phoneNumber - Phone number in international format
 * @returns {string|null} - Country code in lowercase (e.g., 'us', 'br', 'es') or null
 */
export const getCountryCodeFromPhone = phoneNumber => {
  if (!phoneNumber) return null;

  try {
    const parsed = parsePhoneNumber(phoneNumber);
    if (parsed && parsed.country) {
      return parsed.country.toLowerCase();
    }
    return null;
  } catch (error) {
    return null;
  }
};

/**
 * Get country flag HTML from phone number
 * @param {string} phoneNumber - Phone number in international format
 * @returns {string} - HTML string with flag icon or empty string
 */
export const getCountryFlagFromPhone = phoneNumber => {
  const countryCode = getCountryCodeFromPhone(phoneNumber);
  if (!countryCode) return '';

  return `<span class="fi fi-${countryCode}"></span>`;
};

/**
 * Check if phone number is valid
 * @param {string} phoneNumber - Phone number to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const isValidPhoneNumber = phoneNumber => {
  if (!phoneNumber) return false;

  try {
    const parsed = parsePhoneNumber(phoneNumber);
    return parsed ? parsed.isValid() : false;
  } catch (error) {
    return false;
  }
};
